import { css } from '@emotion/react'

export const title = css`
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  padding: 16px 48px 12px 32px;
  font-family: 'GT-Flexa-Bold-Trial';
  > span {
    font-size: 28px;
  }
`

export const historyGrid = css`
  display: grid;
  grid-template-columns: 1fr 1fr 1.4fr 1fr 1.4fr;
`
